import * as React from 'react';
import { TwitterTimelineEmbed } from 'react-twitter-embed';

import * as style from 'styles/components/match/page/twitter.module.scss';

const MatchTwitter = () => (
        <div className={style.twitterTimeline}>
            <TwitterTimelineEmbed
                sourceType="profile"
                screenName="Hammarbyfotboll"
                options={{
                    width: 380,
                    height: 773,
                }}
                theme="dark"
            />
        </div>
    );

export default MatchTwitter;
